import React, { useRef, useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Button, Col, Dropdown, Layout, Menu, Row } from "antd";
import logo from "../../assets/images/Logo.jpg";
import BackEnd from "../../assets/images/BackendCard.jpg";
import FrontEnd from "../../assets/images/FrontendCard.jpg";
import WebSite from "../../assets/images/WebCard.jpg";
import Design from "../../assets/images/UXUICard.jpg";
import WebApplication from "../../assets/images/WebCard.jpg";
import ERP from "../../assets/images/ERPCard.jpg";
import ESG from "../../assets/images/ESGCard.jpg";
import UXUI from "../../assets/images/UXUI2Card.jpg";
import { useBoolean, useClickAway, useSize } from "ahooks";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";
import styles from "../../App.module.scss";
import stylesHeader from "./Header.module.scss";
import i18n from "../../i18n";
import LazyLoad from "react-lazy-load";
import { TranslationOutlined } from "@ant-design/icons";

const { Header, Content } = Layout;

const HeaderMain = (isOutHeader: any) => {
  type DropCardProps = {
    text: string;
    img: string;

    onClick: () => void;
  };
  type Item = {
    text: string;
    img: string;
    type: string;
  };
  type MenuLinkProps = {
    text: string;
    onClick: () => void;
    dataTestId?: string;
  };
  type ItemsProps = {
    items: Item[];
    category: string;
    visible?: boolean;
  };

  const size = useSize(document.querySelector("body"));
  const divRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const [menuItemChosen, setMenuItemChosen] = useState("");
  const [isHeaderHover, setHeaderHover] = useState(false);
  const [isMenuOpen, { toggle: toggleMenu, setFalse: hideMenu }] =
    useBoolean(false);
  const [pageWidth, setPageWidth] = useState(window.innerWidth);
  const navigate = useNavigate();
  const handleResize = () => {
    setPageWidth(window.innerWidth);
  };
  useClickAway(() => {
    isMenuOpen && hideMenu();
  }, [divRef, buttonRef]);
  function handleGoTo(filterName: string, filterValue: string) {
    if (filterValue)
      navigate({
        pathname: "/portfolio",
        search: `?${filterName}=${filterValue}`,
      });
  }
  const dynamicStyles: any = pageWidth > 576 ? { display: "none" } : undefined;
  const delayMenuChoose = (item: string) => {
    setTimeout(() => {
      setMenuItemChosen(item);
    }, 300);
  };
  const disableScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    const scrollLeft =
      window.pageXOffset || document.documentElement.scrollLeft;

    window.onscroll = function () {
      window.scrollTo(scrollLeft, scrollTop);
    };
  };
  const enableScroll = () => {
    window.onscroll = function () {};
  };

  useEffect(() => {
    if (!isMenuOpen) enableScroll();
    else {
      disableScroll();
    }
  }, [isMenuOpen]);

  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  useEffect(() => {
    window.addEventListener("resize", handleResize);
    return () => {
      if (pageWidth < 576) {
        setMenuItemChosen("");
      }
      if (pageWidth > 576) {
        hideMenu();
      }
    };
  }, [pageWidth]);

  const services = [
    { text: "Back-end \n development", img: BackEnd, type: "backend" },
    { text: "Front-end \n development", img: FrontEnd, type: "frontend" },
    {
      text: "Web Sites \n /Application",
      img: WebSite,
      type: "web-applications",
    },
    { text: `UI/UX \n Design`, img: Design, type: "design" },
  ];
  const portfolio = [
    {
      text: "Web \n applications",
      img: WebApplication,
      type: "Web Application",
    },
    { text: "ERP/CRM \n systems", img: ERP, type: "ERP" },
    { text: "ESG \n Systems", img: ESG, type: "ESG" },
    { text: "UI/UX \n Design", img: UXUI, type: "UI/UX Design" },
  ];

  const isActiveHover = (tab: string) => {
    return tab === menuItemChosen;
  };
  useEffect(() => {
    !isHeaderHover && setMenuItemChosen("");
  }, [isHeaderHover]);
  const handleClickDropCard = (item: Item) => {
    menuItemChosen === "portfolio" && handleGoTo("type", item.type);
    menuItemChosen === "services" &&
      navigate({ pathname: `services/${item.type}` });
  };
  const handleChangeLanguage = (language: string) => {
    i18n.changeLanguage(language);
  };
  const DropCard: React.FC<DropCardProps> = ({ text, img, onClick }) => {
    return (
      <LazyLoad>
        <div
          className={styles.dropCard}
          onClick={onClick}
          style={{ backgroundImage: `url(${img})` }}
        >
          <Row className={styles.dropCardTitle}> {text}</Row>
          <Row>
            {" "}
            {/* <img src={img} className={styles.imgStyle} alt="" /> */}
          </Row>
        </div>
      </LazyLoad>
    );
  };

  const DropMenu: React.FC<ItemsProps> = ({ items, category }) => {
    return (
      <div
        className={
          menuItemChosen === category && isHeaderHover && pageWidth > 576
            ? styles.headerDropMenuStyle
            : styles.headerDropMenuHidden
        }
        onMouseLeave={() => {
          setHeaderHover(false);
          setMenuItemChosen("");
        }}
      >
        {items.map((item) => {
          return (
            <LazyLoad>
              <DropCard
                text={item.text}
                img={item.img}
                onClick={() => {
                  setMenuItemChosen("");
                  setHeaderHover(false);
                  handleClickDropCard(item);
                }}
              />
            </LazyLoad>
          );
        })}
      </div>
    );
  };
  const MenuLink: React.FC<MenuLinkProps> = ({ text, onClick, dataTestId }) => {
    return (
      <>
        <span
          className={styles.menuItem}
          onClick={onClick}
          data-testid={dataTestId}
        >
          {text}
        </span>
      </>
    );
  };

  const languageButtons = (
    <Menu>
      <Menu.Item
        key="en"
        className={i18n.language === "en" ? stylesHeader.languagesActive : ""}
        onClick={() => handleChangeLanguage("en")}
      >
        <Button size="large" type="text">
          English
        </Button>
      </Menu.Item>

      <Menu.Item
        key="de"
        className={i18n.language === "de" ? stylesHeader.languagesActive : ""}
        onClick={() => handleChangeLanguage("de")}
      >
        <Button size="large" type="text">
          Deutsche
        </Button>
      </Menu.Item>
    </Menu>
  );

  return (
    <>
      <Header
        style={{ position: "fixed", width: "100%", zIndex: 1000 }}
        className={
          isHeaderHover ? stylesHeader.animatedHeader : stylesHeader.hidden
        }
        onMouseLeave={() => {
          setHeaderHover(false);
          setMenuItemChosen("");
        }}
      >
        <div
          onMouseLeave={() => {
            setHeaderHover(false);
            setMenuItemChosen("");
          }}
        >
          <Row justify="space-between" className={styles.headerRow}>
            <Col>
              <Link to="/" className={styles.logoBlock}>
                <div>
                  <img
                    src={logo}
                    alt="HaltenTech"
                    className={styles.logoImage}
                  />
                </div>
                {size?.width! > 768 && <div>HaltenTech</div>}
              </Link>
            </Col>
            {pageWidth > 576 ? (
              <Col className={styles.headerRowDrop}>
                <span
                  onMouseEnter={() => {
                    setHeaderHover(true);

                    menuItemChosen === ""
                      ? delayMenuChoose("services")
                      : setMenuItemChosen("services");
                  }}
                  className={styles.headerLink}
                  style={{
                    textDecoration: `${
                      isActiveHover("services") && isHeaderHover
                        ? "underline"
                        : ""
                    }`,
                  }}
                  onClick={() => {
                    if (pageWidth < 1025) {
                      if (menuItemChosen === "services")
                        navigate({
                          pathname: "/services",
                        });
                      else {
                        setMenuItemChosen("services");
                      }
                    } else {
                      navigate({
                        pathname: "/services",
                      });
                    }
                  }}
                >
                  Services
                </span>

                <span
                  onMouseEnter={() => {
                    setHeaderHover(true);

                    menuItemChosen === ""
                      ? delayMenuChoose("portfolio")
                      : setMenuItemChosen("portfolio");
                  }}
                  onClick={() => {
                    if (pageWidth < 1025) {
                      if (menuItemChosen === "portfolio")
                        navigate({
                          pathname: "/portfolio",
                        });
                      else {
                        setMenuItemChosen("portfolio");
                      }
                    } else {
                      navigate({
                        pathname: "/portfolio",
                      });
                    }
                  }}
                  className={styles.headerLink}
                  style={{
                    textDecoration: `${
                      isActiveHover("portfolio") && isHeaderHover
                        ? "underline"
                        : ""
                    }`,
                  }}
                >
                  Portfolio
                </span>
                <Link
                  onMouseEnter={() => {
                    setMenuItemChosen("contacts");
                    setHeaderHover(false);
                  }}
                  onClick={() => setMenuItemChosen("")}
                  to="/contacts"
                  className={styles.headerLink}
                  style={{
                    textDecoration: `${
                      isActiveHover("contacts") ? "underline" : ""
                    }`,
                  }}
                >
                  Contacts
                </Link>
                <span
                  className={`${styles.headerLink} ${styles.headerLinkLang}`}
                >
                  <Dropdown
                    overlay={languageButtons}
                    overlayClassName={stylesHeader.languagesMenu}
                  >
                    <TranslationOutlined
                      className={stylesHeader.languagesIcon}
                    />
                  </Dropdown>
                </span>
              </Col>
            ) : (
              <Col>
                <Button
                  ref={buttonRef}
                  icon={
                    <FontAwesomeIcon
                      icon={faBars}
                      className={styles.menuIcon}
                    />
                  }
                  className={styles.menuButton}
                  onClick={() => {
                    toggleMenu();
                  }}
                  data-testid="toggleButton"
                />
              </Col>
            )}
          </Row>
          {isHeaderHover && (
            <>
              <LazyLoad>
                <DropMenu items={services} category="services" />
              </LazyLoad>
              <LazyLoad>
                <DropMenu items={portfolio} category="portfolio" />
              </LazyLoad>
            </>
          )}
        </div>
      </Header>
      <Content>
        <div
          ref={divRef}
          style={dynamicStyles}
          className={isMenuOpen ? styles.openedMenu : styles.menu}
        >
          <Link
            to="/services"
            onClick={hideMenu}
            className={styles.menuItemTitle}
          >
            Services
          </Link>
          {services.map((item) => {
            return (
              <MenuLink
                text={item.text}
                onClick={() => navigate({ pathname: `services/${item.type}` })}
              />
            );
          })}

          <Link
            to="/portfolio"
            className={styles.menuItemTitle}
            onClick={hideMenu}
            data-testid="portfolioLink"
          >
            Portfolio
          </Link>
          {portfolio.map((item) => {
            return (
              <MenuLink
                text={item.text}
                onClick={() => handleGoTo("type", item.type)}
                dataTestId="portfolioLink"
              />
            );
          })}
          <Link
            to="/contacts"
            className={styles.menuItemTitle}
            onClick={hideMenu}
          >
            Contacts
          </Link>
          <div className={styles.menuItemTitle}>Languages</div>
          <div className={stylesHeader.languagesMobile}>
            <div className={stylesHeader.languagesMobile}>
              <Button
                className={
                  i18n.language === "en" ? stylesHeader.languagesActive : ""
                }
                onClick={() => {
                  handleChangeLanguage("en");
                  hideMenu();
                }}
                size="large"
                type="text"
              >
                English
              </Button>
              <Button
                className={
                  i18n.language === "de" ? stylesHeader.languagesActive : ""
                }
                onClick={() => {
                  handleChangeLanguage("de");
                  hideMenu();
                }}
                size="large"
                type="text"
              >
                Deutsche
              </Button>
            </div>
          </div>
        </div>
      </Content>
    </>
  );
};

export default HeaderMain;
